import React from "react";
import { useTranslation } from "react-i18next";
import SlideIn from "../../ui/SlideIn/SlideIn.js";
import Ticker from "../../ui/Ticker/Ticker";
import "./HeroStyles.scss";

function Hero() {
    const { t } = useTranslation();

    return (
        <section id="hero" className="hero-section">
            <div className="nav-heading">
                <SlideIn direction="up" delay={80}>
                    <h1 data-text={t("hero.title")}>{t("hero.title")}</h1>
                </SlideIn>
                <SlideIn direction="up" delay={130}>
                    <p
                        dangerouslySetInnerHTML={{
                            __html: t("hero.subtitle"),
                        }}
                    />
                </SlideIn>
            </div>
            <div className="work-with">
                <div className="nav-sd-heading">
                    <SlideIn direction="up" delay={200}>
                        <h2>{t("hero.workWith")}</h2>
                    </SlideIn>
                </div>
                <SlideIn delay={200}>
                    <div className="ticker-container">
                        <Ticker speed={55} />
                    </div>
                </SlideIn>
            </div>
        </section>
    );
}

export default Hero;